import { defineMessages } from "@formatjs/intl";

export const messages = defineMessages({
  G2_P5_Tab1_Title: {
    id: `guide02.page05.tab01.title`,
  },
  G2_P5_Tab2_Title: {
    id: `guide02.page05.tab02.title`,
  },
  G2_P5_Tab3_Title: {
    id: `guide02.page05.tab03.title`,
  },

  //Slide1
  G2_P5_S1_Title: {
    id: `guide02.page05.slide01.title`,
  },
  G2_P5_S1_Description: {
    id: `guide02.page05.slide01.description`,
  },
  G2_P5_S1_L1_Title: {
    id: `guide02.page05.slide01.l1.title`,
  },
  G2_P5_S1_L1_Item1: {
    id: `guide02.page05.slide01.l1.item1`,
  },
  G2_P5_S1_L1_Item2: {
    id: `guide02.page05.slide01.l1.item2`,
  },
  //Opens export mix modal
  G2_P5_S1_P1_ButtonLabel: {
    id: `guide02.page05.slide01.p1.buttonLabel`,
  },

  //Slide2
  G2_P5_S2_Title: {
    id: `guide02.page05.slide02.title`,
  },
  G2_P5_S2_Description: {
    id: `guide02.page05.slide02.description`,
  },

  //Opens busses modal
  G2_P5_S2_P1_ButtonLabel1: {
    id: `guide02.page05.slide02.p1.buttonLabel1`,
  },
  //Opens routing modal
  G2_P5_S2_P1_ButtonLabel2: {
    id: `guide02.page05.slide02.p1.buttonLabel2`,
  },
  //Opens dolby modal
  G2_P5_S2_P1_ButtonLabel3: {
    id: `guide02.page05.slide02.p1.buttonLabel3`,
  },
  //Opens adm modal
  G2_P5_S2_P1_ButtonLabel4: {
    id: `guide02.page05.slide02.p1.buttonLabel4`,
  },

  //Slide3
  G2_P5_S3_Title: {
    id: `guide02.page05.slide03.title`,
  },
  G2_P5_S3_Description: {
    id: `guide02.page05.slide03.description`,
  },

  //Modals
  G2_P5_M_Export_Title: {
    id: `guide02.page05.modal.export.title`,
  },
  G2_P5_M_Export_Description: {
    id: `guide02.page05.modal.export.description`,
  },

  G2_P5_M_Busses_Title: {
    id: `guide02.page05.modal.busses.title`,
  },
  G2_P5_M_Busses_Description: {
    id: `guide02.page05.modal.busses.description`,
  },

  G2_P5_M_Routing_Title: {
    id: `guide02.page05.modal.routing.title`,
  },
  G2_P5_M_Routing_Description: {
    id: `guide02.page05.modal.routing.description`,
  },

  G2_P5_M_Dolby_Title: {
    id: `guide02.page05.modal.dolby.title`,
  },
  G2_P5_M_Dolby_Description: {
    id: `guide02.page05.modal.dolby.description`,
  },

  G2_P5_M_Adm_Title: {
    id: `guide02.page05.modal.adm.title`,
  },
  G2_P5_M_Adm_Description: {
    id: `guide02.page05.modal.adm.description`,
  },
});
